import { useState } from "react";

import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { crmListsQueryKeys } from "app/pages/sales-intelligence/modules/lists/sub-modules/crm-list/services/queries/queryKeyFactory";
import type { CrmListDto, ListsDto } from "app/pages/sales-intelligence/modules/lists/types/dto";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

type CRMListResponse = UseQueryResult<ListsDto<CrmListDto>> & {
    page: number;
    setPage: (page: number) => void;
};

const useCRMList = ({ initialPage = 1, pageSize = 10 }): CRMListResponse => {
    const [page, setPage] = useState<number>(initialPage);
    const queryData = useQuery({
        queryKey: crmListsQueryKeys.list(page),
        retry: false,
        throwOnError: true,
        queryFn(): Promise<ListsDto<CrmListDto>> {
            return salesApiService.crmList.fetchList({ page, pageSize });
        },
    });

    return {
        ...queryData,
        page,
        setPage,
    };
};

export default useCRMList;
